module.exports = __webpack_public_path__ + "img/footerc_301.aec532f2.jpg";